import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Globais from "../../components/Globais";
// import env from "../../../.env";

const Container = styled.div`
  display: flex;
  width: 100%;

  justify-content: flex-start;
  align-items: center;

  a:link {
    text-decoration: none;
  }
  @media (max-width: 400px) {
    display: none;
  }

  @media (min-width: 300px) {
    justify-content: center;
  }
  @media (min-width: 700px) {
    justify-content: flex-start;
  }
`;

const Titulo = styled.h1`
  font-size: 1rem;

  font-family: arial, arial, helvetica, san-serif;
  color: ${Globais.CorTexto};
  padding: 10px;

  line-height: 0.6em;
  // border: 1px solid white;
  // justify-self: center;
  text-align: center;
  font-weight: bold;
  &:hover {
    cursor: pointer;
  }

  // @media (max-width: 300px) {
  //   margin-left: 3rem;
  // }
  @media (min-width: 700px) {
    margin-left: 3rem;
  }
  @media (min-width: 800px) {
    margin-left: 4rem;
  }
  @media (min-width: 900px) {
    margin-left: 5rem;
  }
  @media (min-width: 1000px) {
    margin-left: 6rem;
  }

  @media (min-width: 1110px) {
    // font-size: 1.8rem;
    margin-left: 7rem;
  }
  @media (min-width: 1200px) {
    margin-left: 8rem;
  }
  @media (min-width: 1400px) {
    // font-size: 2.5em;
    margin-left: 9rem;
  }
`;
console.log(Globais.TITULO);
///
export default function AppBar() {
  return (
    <Container>
      <Link to={Globais.DOMINIOFRONT+"/inicio"}>
        <Titulo>{Globais.TITULO}</Titulo>
      </Link>
    </Container>
  );
}
